import { makeStyles } from '@material-ui/core';
import React from 'react';

interface LayoutProps {
  children?: React.ReactNode;
}

const useStyles = makeStyles({
  pageToolbar: {
    backgroundColor: 'rgba(217, 220, 225, 1)',
    padding: '1rem',
    boxSizing: 'border-box',
    boxShadow: '0px 2px 7px 0px rgba(0,0,0,0.28)',
    // position: 'relative',
    zIndex: 10,
    minHeight: '7.313rem', // 85px
  },
});

const PageToolbar: React.FC<LayoutProps> = (props) => {
  const { children } = props;
  const classes = useStyles();
  return <div className={classes.pageToolbar}>{children}</div>;
};

export { PageToolbar };
